import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, message, Select } from 'antd';
import { userRegister } from '../../api/User';
import { useNavigate, Link } from 'react-router-dom';
import { useState,useRef } from 'react';
import {CustomInput,CustomInputPassword} from '../../components/CustomForm';
import ReCAPTCHA from "react-google-recaptcha";


const array = require('lodash/object');

const { Option } = Select;

const RegisterContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 184px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Content = styled.div`
  width: 470px;
`;
const Title = styled.h2`
  font-size: 32px;
  color: #fff;
`;

const Tip = styled.div`
  width: 100%;
  text-align: left;
  padding-bottom: 20px;
  a {
    text-decoration: underline;
    color: #18eac4;
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

// const style = {
//   height: '50px',
//   borderRadius: '6px',
// };

const Register = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // 提交表单，注册

  const captchaRef = useRef(null);

  const onFinish = async (values) => {

    //google recaptcha
    const token = await captchaRef.current.executeAsync();
    captchaRef.current.reset();
    values.response_token = token;
    
    const FormDate = array.omit(values, ['prefix']);
    setLoading(true);
    // console.log(FormDate);
    try {
      const res = await userRegister(FormDate);
      setLoading(false);
      if (res.code === '10000') {
        message.success('Registration success');
        // 成功后跳转验证界面
        navigate('/register/verfiytip', {
          state: { from: '/register', userName: values.email },
          replace: true,
        });
        form.resetFields();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    message.error('validateField');
  };

  return (
    <RegisterContainer>
      <Content>
        <Title>{t('RegisterPage.title')}</Title>
        <Tip>
          {t('RegisterPage.tips1')}
          here to register as a <Link to="/project/register" style={{
            fontSize:'14px',
            textDecoration: 'none'
          }}>Project Manager</Link>
          .
        </Tip>
        <Form
          form={form}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {/* username */}
          <Form.Item
            name="username"
            hasFeedback
            rules={[{ required: true, message: 'Please input your username' }]}
          >
            <CustomInput
              placeholder={t('RegisterPage.Username / Nickname')}
            />
          </Form.Item>

          {/* email */}
          <Form.Item
            name="email"
            hasFeedback
            rules={[
              { required: true, message: 'Please input your email' },
              {
                type: 'email',
                message: 'The input is not valid email',
              },
            ]}
          >
            <CustomInput
              placeholder={t('RegisterPage.Email address')}
            />
          </Form.Item>

          {/* <Form.Item>
            <div
              style={{
                display: 'flex',
              }}
            >
              <Form.Item
                name="realname"
                hasFeedback
                noStyle
                rules={[
                  { required: true, message: 'Please input your Reale Name!' },
                ]}
              >
                <Input
                  style={{ ...style, marginRight: '10px' }}
                  placeholder={t('RegisterPage.Real Name')}
                />
              </Form.Item>
              <Form.Item
                name="mobile"
                noStyle
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Please input your phone number!',
                  },
                  {
                    type: 'phone',
                    message: 'The input is not valid phone number!',
                  },
                ]}
              >
                <Input
                  style={{ ...style, marginLeft: '10px' }}
                  placeholder={t('RegisterPage.Phone number')}
                />
              </Form.Item>
            </div>
          </Form.Item> */}

          {/* password */}
          <Form.Item
            name="password"
            hasFeedback
            rules={[{ required: true, message: 'Please input your password' }]}
          >
            <CustomInputPassword
              // style={style}
              placeholder={t('RegisterPage.Password')}
            />
          </Form.Item>

          {/* confrim password */}
          <Form.Item
            name="password_confirmation"
            hasFeedback
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please input your password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      'The two passwords that you entered do not match'
                    )
                  );
                },
              }),
            ]}
          >
            <CustomInputPassword
              // style={style}
              placeholder={t('RegisterPage.Confirm Password')}
              
            />
          </Form.Item>
            <ReCAPTCHA 
              sitekey={process.env.REACT_APP_SITE_KEY}
              ref={captchaRef}
              size={'invisible'}
              theme={'dark'}
             />
          <Form.Item>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  height: '42px',
                  backgroundColor: '#18EAC4',
                  borderColor: '#18EAC4',
                  color: '#000',
                  borderRadius: '6px',
                }}
              >
                {t('RegisterPage.register')}
              </Button>
            </ButtonGroup>
          </Form.Item>
        </Form>
      </Content>
    </RegisterContainer>
  );
};

export default Register;
